import { Flex } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import { TextRegular } from 'UiKit/typography';
import { importScheduleText } from 'Const/schedule';

const DialogErrorUpload = ({ data }) => {
  return (
    <Flex width={'100%'} flexDirection={'column'} gap="8px">
      <Condition statement={data.successCount}>
        <Flex justifyContent={'space-between'} backgroundColor="var(--color-success10)" padding={'10px'} width={'100%'}>
          <TextRegular>{importScheduleText.successUploadSchedule}</TextRegular>
          <TextRegular>{data.successCount}</TextRegular>
        </Flex>
      </Condition>
      <Flex justifyContent={'space-between'} backgroundColor="var(--color-error10)" padding={'10px'} width={'100%'}>
        <TextRegular>{importScheduleText.failedUploadSchedule}</TextRegular>
        <TextRegular>{data.failedCount}</TextRegular>
      </Flex>
    </Flex>
  );
};

export default DialogErrorUpload;
